import { Box } from "@mui/system";
import React from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CircleIcon from "@mui/icons-material/Circle";
import { Typography } from "@mui/material";
const CheckerComponent = ({ label, isCheck }) => {
  return (
    <>
      <Box display={"flex"} mt={0.5} my={2}>
        {isCheck ? (
          <CheckCircleIcon color="primary" fontSize={"small"} />
        ) : (
          <CircleIcon sx={{ color: "#dff2ef" }} fontSize={"small"} />
        )}
        <Typography variant="body1" color={"#5c5858"} mx={1}>
          {label}
        </Typography>
      </Box>
    </>
  );
};
export default CheckerComponent;
